import { GLYPH_HEIGHT, GLYPH_WIDTH, LETTER_SPACING, glyphFor, lineWidthInCols }
  from "./pixelFont";

export interface TextMaskOptions {
  /** Blank rows between stacked lines. Defaults to 1. */
  lineSpacing?: number;
}

/**
 * Renders lines of text into a 0/1 grid. Shorter lines are centred against the
 * widest one so a stacked word stays visually balanced.
 */
export function textToMask(lines: string[], options: TextMaskOptions = {}): number[][] {
  const lineSpacing = options.lineSpacing ?? 1;
  const widths = lines.map(lineWidthInCols);
  const cols = Math.max(...widths);
  const rows = lines.length * GLYPH_HEIGHT + (lines.length - 1) * lineSpacing;

  const mask: number[][] = Array.from({ length: rows }, () => new Array(cols).fill(0));

  lines.forEach((line, lineIndex) => {
    const rowOffset = lineIndex * (GLYPH_HEIGHT + lineSpacing);
    let col = Math.floor((cols - widths[lineIndex]) / 2);

    for (const character of line) {
      const glyph = glyphFor(character);
      for (let r = 0; r < GLYPH_HEIGHT; r++) {
        for (let c = 0; c < GLYPH_WIDTH; c++) {
          if (glyph[r][c]) mask[rowOffset + r][col + c] = 1;
        }
      }
      col += GLYPH_WIDTH + LETTER_SPACING;
    }
  });

  return mask;
}
